import styled from "styled-components";

export const AppContainer = styled.div`
  background: var(--background-color);
  width: 100%;
  min-width: 0;
  display: flex;
  // align-items: center;
  // align-content: center;
  // justify-content: center;
  flex-direction: row;
`;

export const Container = styled.div`
  width: 100%;
  min-width: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NotFoundContainer = styled.div`
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  color: red;
  svg {
    width: 150px;
  }
  h5 {
    text-align: center;
    padding: 10px 0;
  }
`;
